import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Typography, message } from "antd";
import ListTable from "common/ListTable";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { cglFormatDate, hasPermission } from "utils/functions";
import { DIGITALIZATION_DEFECTS } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import AppContent from "../../../common/AppContent";
import AppPageHeader from "../../../common/PageHeader";
import {
  DIGITALIZATION_DEFECT_VIEW_PERMISSION,
  NO_PERMISSION_REQUIRED,
} from "../../../routes/permissions";
import ExtraContent from "../../Configuration/CommonComponents/ExtraContent";
import FilterComponent from "../../Configuration/CommonComponents/FilterComponent";

const ProductionDefect = () => {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [refresh, setRefresh] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDefects, setTotalDefects] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  // Antd
  const { Title } = Typography;

  console.log("showFilter", showFilter);

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const getAllDefectsList = useCallback(async () => {
    setLoading(true);
    const body = {
      page: currentPage,
      ...(filterValues?.date && { date: filterValues.date }),
      ...(filterValues?.line_id && { line_id: filterValues.line_id }),
      ...(filterValues?.operation && { operation: filterValues.operation }),
      ...(filterValues?.category_id && {
        category_id: filterValues.category_id,
      }),
      ...(filterValues?.user_id && { user_id: filterValues.user_id }),
      ...(filterValues?.per_page && { per_page: filterValues.per_page }),
    };
    const query = `${DIGITALIZATION_DEFECTS}`;

    const response = await getData(query, false, body);
    if (response?.status === 200) {
      setLoading(false);
      setMetaData({
        defaultPageSize: response?.data?.data?.per_page,
        current: response?.data?.data?.current_page,
        defaultCurrent: response?.data?.data?.current_page,
        total: response?.data?.data?.total,
      });
      console.log("tabledata res", response?.data?.data?.data);

      setTableData(response?.data?.data?.data || []);
      setTotalDefects(response?.data?.data?.total || 0);
    } else {
      setLoading(false);
      message.error("Something went wrong! Please try again.");
    }
  }, [currentPage, filterValues]);

  const exportProductionHour = async (filterValues) => {
    setFilterValues(filterValues);
  };

  // Effects
  useEffect(() => {
    getAllDefectsList();
  }, [currentPage, filterValues, getAllDefectsList]);

  const refetch = () => {
    setRefresh(refresh + 1);
  };
  const changePage = (newPage) => {
    setCurrentPage(newPage);
  };
  const menu = (data) => (
    <Menu
      items={[
        {
          label: (
            <Link to={`/digitalization/production-defect/view/${data.id}`}>
              <EyeOutlined /> View
            </Link>
          ),
          key: "1",
          disabled: !hasPermission([DIGITALIZATION_DEFECT_VIEW_PERMISSION]),
        },
      ]}
    />
  );

  const tableColumns = [
    // {
    //   title: "Sl",
    //   dataIndex: "sl",
    //   key: "sl",
    //   width: 50,
    //   render: (_, __, index) => index + 1,
    // },
    {
      title: "Entry Date",
      dataIndex: ["date"],
      key: "date",

      render: (value, record) => {
        return <span>{value ? cglFormatDate(value) : "N/A"}</span>;
      },
    },
    {
      title: "Entry Time",
      dataIndex: ["time"],
      key: "time",
      render: (value, record) => {
        return (
          <span>{value ? moment(value, "HH:mm").format("HH:mm") : "N/A"}</span>
        );
      },
    },
    {
      title: "Supervisor Name",
      dataIndex: ["user", "name"],
      key: "name",
    },
    {
      title: "Line",
      dataIndex: ["line_info", "name"],
      key: "line_id_name",

      align: "center",
    },
    {
      title: "Buyer",
      dataIndex: ["buyer", "name"],
      key: "buyer_name",

      align: "center",
    },
    {
      title: "Style",
      dataIndex: ["style", "style_no"],
      key: "style_no",
    },
    {
      title: "Sub Style",
      dataIndex: ["sub_style", "sub_style_no"],
      key: "sub_style_no",
    },
    {
      title: "Operation",
      dataIndex: ["operation", "operation_info", "sam_data_bank", "name"],
      key: "line_id_name",
    },
    {
      title: "Operator",
      dataIndex: ["operator", "name"],
      key: "operator_name",
    },
    {
      title: "ID Card No",
      dataIndex: ["operator", "additional_info", "id_card_no"],
      key: "id_card_no",
    },
    {
      title: "Category",
      dataIndex: ["category", "name"],
      key: "category",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",

      align: "center",
    },
    {
      title: "Reason",
      dataIndex: ["details"],
      key: "quantity",

      render: (value, record) => {
        return (
          <div>
            {Array.isArray(record?.details) && record?.details?.length > 0
              ? record?.details?.map((item) => item?.reason?.reason).join(", ")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Recommendation",
      dataIndex: ["recommendation"],
      key: "quantity",

      render: (value, record) => {
        return (
          <div>
            {Array.isArray(record?.recommendations) &&
            record?.recommendations?.length > 0
              ? record?.recommendations
                  ?.map((item) => item?.recommendation?.recommendation)
                  .join(", ")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => (
        <div className="cursore-pointer">
          <Dropdown overlay={menu(record)}>
            <MoreOutlined style={{ fontSize: "20px" }} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const exportFabric = async (filterValues) => {
    const { date, line_id, operation, category_id, user_id } = filterValues;
    const bodyData = {
      ...(date && { date: moment(date).format("YYYY-MM-DD") }),
      ...(line_id && { line_id }),
      ...(operation && { operation }),
      ...(category_id && { category_id }),
      ...(user_id && { user_id }),
    };
    console.log("bodyData", bodyData);
    const query = `/api/digitalization/defects/export-report`;

    const response = await getData(
      query,
      false,
      bodyData,
      { "Content-Type": "blob" },
      "arraybuffer",
    );

    if (response && response?.data) {
      // Download the file
      const outputFilename = `production_tracking_report.xlsx`;

      // If you want to download file automatically using link attribute.
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      message.success("Download Successfully");
      refetch();
    } else {
      message.error("Something went wrong");
    }
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <FilterComponent
        tableData={tableData}
        filterAPI={(value) => exportProductionHour(value)}
        filterName={"production_defect"}
        // searchButtonText={"Search"}
        // defaultOpen
        setShowFilter={setShowFilter}
        showFilter={showFilter}
        preview={"Download"}
        isPreview={true}
        previewFunction={exportFabric}
      />
    ),
    [showFilter],
  );

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                refresh={refresh}
                setRefresh={setRefresh}
                handleAddItemOpen={exportProductionHour}
                hideAddButton={true}
                disabled={!hasPermission([NO_PERMISSION_REQUIRED])}
                setShowFilter={setShowFilter}
                showFilter={showFilter}
              />
            }
            title={<Title level={5}>Production Defects</Title>}
          />
        }
        content={
          <>
            <div className="table" style={{ marginTop: 10 }}>
              {memoizedCustomFilter}
              <div
                style={{
                  paddingTop: 10,
                  marginBottom: 10,
                  marginInlineStart: 5,
                }}
              >
                <Title level={5} style={{ fontWeight: "normal" }}>
                  Total Defects: {totalDefects}
                </Title>
              </div>
              <ListTable
                loading={loading}
                dataSource={tableData}
                columns={tableColumns.map((col, idx) => ({
                  ...col,
                  fixed: idx < 4 ? "left" : undefined,
                }))}
                scroll={{
                  x: 1200,
                  y: 500,
                }}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: metaData?.defaultPageSize,
                  current: metaData?.current,
                  onChange: (newPage) => {
                    changePage(newPage);
                  },
                  defaultCurrent: metaData?.defaultCurrent,
                  total: metaData?.total,
                }}
                bordered
                sticky
              />
            </div>
          </>
        }
      />
    </>
  );
};

export default ProductionDefect;
